export enum EmailStatus {
  Scheduled = 'scheduled', // draft email is not created yet.
  Queued = 'queued',
  Out = 'out',
  Sent = 'sent',
  Received = 'received',
  Failed = 'failed',
  Deleted = 'deleted',
}
